import axios from "../api/axios";
import { useContext } from "react";
import AuthContext from "../contexts/AuthProvider";

const useRefreshToken = () => {
    const { setAuth } = useContext(AuthContext);
    
    const refresh = async () => {
        try {
            const response = await axios.get("/auth/refresh", {
                withCredentials: true
            });
            
            
            setAuth(prev => {
                const newAuth = { 
                    ...prev, 
                    accessToken: response.data.accessToken,
                    // Aggiorna anche le altre informazioni se presenti nella risposta
                    ...(response.data.userType && { userType: response.data.userType }),
                    ...(response.data.customerCode && { customerCode: response.data.customerCode }),
                    ...(response.data.fullName && { fullName: response.data.fullName }),
                    ...(response.data.role && { role: response.data.role }),
                    ...(response.data.email && { email: response.data.email })
                };
                return newAuth;
            });
            
            return response.data.accessToken;
        } catch (err) {
            console.error("Refresh token error:", err);
            throw err;
        }
    };
    
    return refresh;
};

export default useRefreshToken;

